// extracted by mini-css-extract-plugin
module.exports = {"default":"SanityPortableText_default__tP0GI"};